module.exports = __webpack_public_path__ + "img/document-upload.46359e5e.svg";